import { Component, Input } from '@angular/core';
import { FormArray, ReactiveFormsModule } from '@angular/forms';

import { NgUtils } from 'tiime-expert-utils';
import { TiimeCheckboxModule } from 'tiime-material';

import { GIFileType } from '@enums/gi-file-type.enum';
import { ContractEmailAttachmentForm } from '@gi/forms/contract-email-attachment-form';
import { CodeAndLabel } from '@models/code-and-label';
import { CodeAndLabelPipe } from '@shared-pipes/code-and-label/code-and-label.pipe';

@Component({
  selector: 'app-multiple-attachments-selector',
  standalone: true,
  imports: [ReactiveFormsModule, TiimeCheckboxModule, CodeAndLabelPipe],
  templateUrl: './multiple-attachments-selector.component.html',
  styleUrls: ['./multiple-attachments-selector.component.scss']
})
export class MultipleAttachmentsSelectorComponent {
  @Input() attachments: FormArray<ContractEmailAttachmentForm>;
  @Input() contractFileTypes: CodeAndLabel<GIFileType>[];

  readonly trackByIndex = NgUtils.trackByIndex;
}
